


































































































































































import { Component, Vue } from 'vue-property-decorator';

import { parseCSVFile, ProspectCSVData, parseProspectFromCSVRow } from '@/utils/csvProspectParser';

import { postCustomerPrescriber } from '@/api/api';

import * as XLSX from 'xlsx';

interface ValidationResult {
    valid: boolean;
    errors: string[];
}

interface ProspectValidation {
    prospect: ProspectCSVData;
    rowNumber: number;
    validation: ValidationResult;
}

interface ImportResult {
    total: number;
    success: number;
    failed: number;
    errors: Array<{ row: number; name: string; error: string }>;
}

const COLUMN_NAMES: { [key: string]: string } = {
    'civility': 'Civilité 1er Acquéreur',
    'first_firstname': 'Prénom 1er Acquéreur',
    'first_lastname': 'Nom 1er Acquéreur',
    'email': 'Email 1er Acquéreur',
    'address.street': 'Adresse 1er Acquéreur',
    'address.postal_code': 'Code postal 1er Acquéreur',
    'address.city': 'Ville 1er Acquéreur',
    'mobile': 'Mobile 1er Acquéreur',
    'civility_2': 'Civilité 2ème Acquéreur',
    'second_firstname': 'Prénom 2ème Acquéreur',
    'second_lastname': 'Nom 2ème Acquéreur',
    'email_2': 'Email 2ème Acquéreur',
    'date_of_birth_2': 'Date naissance 2ème Acquéreur',
    'address_2.street': 'Adresse 2ème Acquéreur',
    'address_2.postal_code': 'Code postal 2ème Acquéreur',
    'address_2.city': 'Ville 2ème Acquéreur',
    'mobile_2': 'Mobile 2ème Acquéreur',
    'job_status': 'Statut professionnel',
    'job_status_2': 'Statut professionnel 2ème Acquéreur',
};

function validateProspect(prospect: ProspectCSVData): ValidationResult {
    const errors: string[] = [];
    
    if (!prospect.first_firstname || prospect.first_firstname.trim() === '') {
        errors.push('Prénom 1er Acquéreur manquant');
    }
    
    if (!prospect.first_lastname || prospect.first_lastname.trim() === '') {
        errors.push('Nom 1er Acquéreur manquant');
    }
    
    if (!prospect.email || prospect.email.trim() === '') {
        errors.push('Email 1er Acquéreur manquant');
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(prospect.email)) {
        errors.push('Email 1er Acquéreur invalide');
    }
    
    if (!prospect.address.city || prospect.address.city.trim() === '') {
        errors.push('Ville 1er Acquéreur manquante');
    }
    
    if (!prospect.address.postal_code || prospect.address.postal_code.trim() === '') {
        errors.push('Code postal 1er Acquéreur manquant');
    }
    
    // Validate civility is one of the accepted values
    const validCivilities = ['M.', 'Mme.', 'M. et Mme.', 'M. et M.', 'Mme. et Mme.', 'Société'];
    if (prospect.civility && !validCivilities.includes(prospect.civility)) {
        errors.push(`Civilité invalide: "${prospect.civility}". Valeurs acceptées: M., Mme., M. et Mme., M. et M., Mme. et Mme., Société`);
    }
    
    return {
        valid: errors.length === 0,
        errors
    };
}

function convertProspectToCustomer(prospect: ProspectCSVData): any {
    return {
        civility: prospect.civility,
        first_firstname: prospect.first_firstname,
        first_lastname: prospect.first_lastname,
        second_firstname: prospect.second_firstname || null,
        second_lastname: prospect.second_lastname || null,
        company_name: prospect.company_name || null,
        email: prospect.email,
        birthdate: prospect.birthdate || null,
        phone: prospect.mobile || '',
        mobile: prospect.mobile || null,
        workplace: prospect.workplace || null,
        address: {
            street: prospect.address.street || null,
            street2: prospect.address.street2 || null,
            postal_code: prospect.address.postal_code || '',
            city: prospect.address.city || '',
            country: 'France',
            latitude: null,
            longitude: null
        },
        status: prospect.status,
        family_situation: prospect.family_situation || null,
        income_taxe: prospect.income_taxe || null,
        first_household_reference_income_taxe: prospect.first_household_reference_income_taxe || null,
        second_household_reference_income_taxe: prospect.second_household_reference_income_taxe || null,
        people_in_tax_home: prospect.people_in_tax_home || null,
        childrens_in_tax_home: prospect.childrens_in_tax_home || null,
        monthly_pay: prospect.monthly_pay || null,
        share_of_taxe_home: prospect.share_of_taxe_home || null,
        job_status: prospect.job_status || null,
        job_since: prospect.job_since || null,
        real_costs: prospect.real_costs || null,
        rent_collected: prospect.rent_collected || null,
        dividends_before_deduction: prospect.dividends_before_deduction || null,
        other_income_before_deduction: prospect.other_income_before_deduction || null,
        tax_residence: prospect.tax_residence || null,
        tax_number: prospect.tax_number || null,
        tax_before_reduction: prospect.tax_before_reduction || null,
        csg_crds: prospect.csg_crds || null,
        real_estate_taxes: prospect.real_estate_taxes || null,
        dom_deduction: prospect.dom_deduction || null,
        income_deduction: prospect.income_deduction || null,
        income_deduction_reason: prospect.income_deduction_reason || null,
        tax_reduction: prospect.tax_reduction || null,
        tax_reduction_reason: prospect.tax_reduction_reason || null,
        tax_credit: prospect.tax_credit || null,
        investment_horizon: prospect.investment_horizon || null,
        income_goals: prospect.income_goals || null,
        capital_goals: prospect.capital_goals || null,
        retirement_goals: prospect.retirement_goals || null,
        geo_zone: prospect.geo_zone || null,
        acquisition_date: prospect.acquisition_date || null,
        surface: prospect.surface || null,
        rent: prospect.rent || null,
        personnal_apport: prospect.personnal_apport || null,
        lot_price: prospect.lot_price || null,
        notary_fees: prospect.notary_fees || null,
        civility_2: prospect.civility_2 || null,
        date_of_birth_2: prospect.date_of_birth_2 || null,
        address_2: prospect.address_2 ? {
            street: prospect.address_2.street || null,
            street2: prospect.address_2.street2 || null,
            postal_code: prospect.address_2.postal_code || null,
            city: prospect.address_2.city || null,
            country: null,
            latitude: null,
            longitude: null
        } : null,
        email_2: prospect.email_2 || null,
        mobile_2: prospect.mobile_2 || null,
        workplace_2: prospect.workplace_2 || null,
        wedding_date: prospect.wedding_date || null,
        wedding_place: prospect.wedding_place || null,
        wedding_master: prospect.wedding_master || null,
        first_household_reference_income_taxe_2: prospect.first_household_reference_income_taxe_2 || null,
        monthly_pay_2: prospect.monthly_pay_2 || null,
        job_status_2: prospect.job_status_2 || null,
        job_since_2: prospect.job_since_2 || null,
        real_costs_2: prospect.real_costs_2 || null,
        rent_collected_2: prospect.rent_collected_2 || null,
        dividends_before_deduction_2: prospect.dividends_before_deduction_2 || null,
        other_income_before_deduction_2: prospect.other_income_before_deduction_2 || null,
        income_taxe_2: prospect.income_taxe_2 || null,
        income_deduction_2: prospect.income_deduction_2 || null,
        income_deduction_reason_2: prospect.income_deduction_reason_2 || null,
        tax_reduction_2: prospect.tax_reduction_2 || null,
        tax_reduction_reason_2: prospect.tax_reduction_reason_2 || null,
        csg_crds_2: prospect.csg_crds_2 || null,
        tax_credit_2: prospect.tax_credit_2 || null,
        tax_before_reduction_2: prospect.tax_before_reduction_2 || null,
        real_estate_taxes_2: prospect.real_estate_taxes_2 || null,
        dom_deduction_2: prospect.dom_deduction_2 || null,
        tax_residence_c2: prospect.tax_residence_c2 || null,
        tax_number_c2: prospect.tax_number_c2 || null,
        taxes_c2: prospect.taxes_c2 || null,
        study_coordinates: prospect.study_coordinates || null,
        study_contact: prospect.study_contact || null,
        study_mobile: prospect.study_mobile || null,
        study_email: prospect.study_email || null,
        study_address: prospect.study_address ? {
            street: prospect.study_address.street || null,
            street2: prospect.study_address.street2 || null,
            postal_code: prospect.study_address.postal_code || null,
            city: prospect.study_address.city || null,
            country: null,
            latitude: null,
            longitude: null
        } : null,
        max_credit: prospect.max_credit || null,
        max_credit_duration: prospect.max_credit_duration || null,
        rate_excluding_insurance: prospect.rate_excluding_insurance || null,
        tax_chosen: prospect.tax_chosen || null,
        other_conditions: prospect.other_conditions || null
    };
}

function extractErrorDetails(error: any, prospect: ProspectCSVData): string {
    if (!error.response || !error.response.data) {
        return 'Erreur réseau ou serveur indisponible';
    }

    const data = error.response.data;
    
    // Check for duplicate email error first
    if (data.message && data.message.includes('existe déjà avec cette adresse email')) {
        return 'Un prospect existe déjà avec cette adresse email';
    }
    
    if (data.errors && data.errors.children) {
        const errors: string[] = [];
        
        const processErrors = (children: any, prefix: string = '') => {
            for (const fieldName in children) {
                const field = children[fieldName];
                const fullPath = prefix ? `${prefix}.${fieldName}` : fieldName;
                
                if (field.errors && field.errors.length > 0) {
                    const columnName = COLUMN_NAMES[fullPath] || fullPath;
                    let errorMsg = field.errors[0];
                    
                    // Translate common error messages
                    if (errorMsg.includes('should have exactly 5 characters')) {
                        errorMsg = 'Doit contenir exactement 5 caractères';
                    } else if (errorMsg.includes('not valid')) {
                        errorMsg = 'Cette valeur n\'est pas valide';
                    } else if (errorMsg.includes('required')) {
                        errorMsg = 'Ce champ est obligatoire';
                    } else if (errorMsg.includes('already exists')) {
                        errorMsg = 'Cette valeur existe déjà';
                    }
                    
                    errors.push(`${columnName}: ${errorMsg}`);
                }
                
                if (field.children) {
                    processErrors(field.children, fullPath);
                }
            }
        };
        
        processErrors(data.errors.children);
        
        if (errors.length > 0) {
            return errors.join(' | ');
        }
    }
    
    if (data.message) {
        // Translate common backend messages
        if (data.message.includes('existe déjà avec cette adresse email')) {
            return 'Un prospect existe déjà avec cette adresse email';
        }
        return data.message;
    }
    
    return 'Erreur de validation';
}


@Component
export default class ImportProspectsModal extends Vue {
    selectedFile: File | null = null;
    validatedProspects: ProspectValidation[] = [];
    importing: boolean = false;
    validating: boolean = false;
    importProgress: number = 0;
    importResult: ImportResult | null = null;

    get validProspects(): ProspectValidation[] {
        return this.validatedProspects.filter(p => p.validation.valid);
    }

    get invalidProspects(): ProspectValidation[] {
        return this.validatedProspects.filter(p => !p.validation.valid);
    }

    get hasValidatedProspects(): boolean {
        return this.validatedProspects.length > 0;
    }

    onFileSelected(event: Event) {
        const target = event.target as HTMLInputElement;
        if (target.files && target.files.length > 0) {
            this.selectedFile = target.files[0];
            this.validatedProspects = [];
            this.importResult = null;
            this.validateFile();
        }
    }

    clearFile() {
        this.selectedFile = null;
        this.validatedProspects = [];
        this.importResult = null;
        const fileInput = this.$refs.fileInput as HTMLInputElement;
        if (fileInput) {
            fileInput.value = '';
        }
    }

    downloadCSVTemplate() {
        const link = document.createElement('a');
        link.href = '/documents/Exemplaire_Prospects.csv';
        link.download = 'Exemplaire_Prospects.csv';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    }

    downloadExcelTemplate() {
        const link = document.createElement('a');
        link.href = '/documents/Exemplaire_Prospects.xlsx';
        link.download = 'Exemplaire_Prospects.xlsx';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    }

  
        async validateFile() {
            if (!this.selectedFile) return;
            
            this.validating = true;
            this.validatedProspects = [];
            
            try {
                const nameParts = this.selectedFile.name.split('.');
                const fileExtension = nameParts.length > 0 ? nameParts[nameParts.length - 1].toLowerCase() : '';
                let prospects: ProspectCSVData[] = [];
                
                if (fileExtension === 'csv') {
                    // Parse CSV
                    const fileContent = await this.readFileContent(this.selectedFile);
                    prospects = parseCSVFile(fileContent);
                } else if (fileExtension === 'xlsx' || fileExtension === 'xls') {
                    // Parse Excel
                    prospects = await this.parseExcelFile(this.selectedFile);
                } else {
                    const $vs = (this as any).$vs;
                    $vs.notify({
                        color: 'danger',
                        position: 'top-right',
                        title: 'Erreur de format',
                        text: 'Format de fichier non supporté. Utilisez .csv, .xlsx ou .xls',
                    });
                    this.validating = false;
                    this.clearFile();
                    return;
                }
                
                if (prospects.length === 0) {
                    const $vs = (this as any).$vs;
                    $vs.notify({
                        color: 'warning',
                        position: 'top-right',
                        title: 'Fichier vide',
                        text: 'Le fichier ne contient aucun prospect valide',
                    });
                    this.validating = false;
                    this.clearFile();
                    return;
                }
                
                for (let i = 0; i < prospects.length; i++) {
                    const prospect = prospects[i];
                    const rowNumber = i + 5;
                    const validation = validateProspect(prospect);
                    
                    this.validatedProspects.push({
                        prospect,
                        rowNumber,
                        validation
                    });
                }
                
            } catch (error) {
                const $vs = (this as any).$vs;
                let errorMessage = 'Erreur lors de la lecture du fichier';
                
                if (error && error.message) {
                    errorMessage = error.message;
                }
                
                $vs.notify({
                    color: 'danger',
                    position: 'top-right',
                    title: 'Erreur de lecture',
                    text: errorMessage,
                });
                
                console.error('Erreur détaillée:', error);
                this.clearFile();
            } finally {
                this.validating = false;
            }
}




    async confirmImport() {
        this.importing = true;
        this.importProgress = 0;
        
        const result: ImportResult = {
            total: this.validProspects.length,
            success: 0,
            failed: 0,
            errors: []
        };
        
        for (let i = 0; i < this.validProspects.length; i++) {
            const prospectValidation = this.validProspects[i];
            this.importProgress = Math.round(((i + 1) / this.validProspects.length) * 100);
            
            try {
                const customerData = convertProspectToCustomer(prospectValidation.prospect);
                await postCustomerPrescriber(customerData);
                result.success++;
            } catch (e) {
                result.failed++;
                const errorMsg = extractErrorDetails(e, prospectValidation.prospect);
                result.errors.push({
                    row: prospectValidation.rowNumber,
                    name: `${prospectValidation.prospect.first_firstname} ${prospectValidation.prospect.first_lastname}`,
                    error: errorMsg
                });
            }
        }
        
        this.importResult = result;
        this.importing = false;
    }

    closeAndRefresh() {
        this.$emit('close');
        this.$emit('refresh');
    }

    async readFileContent(file: File): Promise<string> {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onload = (e: ProgressEvent) => {
                const target = e.target as FileReader;
                if (target && target.result) {
                    resolve(target.result as string);
                } else {
                    reject(new Error('Failed to read file'));
                }
            };
            reader.onerror = reject;
            reader.readAsText(file, 'UTF-8');
        });
    }



async parseExcelFile(file: File): Promise<ProspectCSVData[]> {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        
        reader.onload = (e: ProgressEvent) => {
            try {
                const target = e.target as FileReader;
                const data = target.result;
                
                if (!data) {
                    reject(new Error('Impossible de lire le contenu du fichier'));
                    return;
                }
                
                let workbook;
                try {
                    workbook = XLSX.read(data, { type: 'binary' });
                } catch (err) {
                    reject(new Error('Le fichier Excel est corrompu ou invalide'));
                    return;
                }
                
                if (!workbook.SheetNames || workbook.SheetNames.length === 0) {
                    reject(new Error('Le fichier Excel ne contient aucune feuille'));
                    return;
                }
                
                const firstSheetName = workbook.SheetNames[0];
                const worksheet = workbook.Sheets[firstSheetName];
                
                if (!worksheet) {
                    reject(new Error('Impossible de lire la première feuille du fichier'));
                    return;
                }
                
                let jsonData: any[];
                try {
                    jsonData = XLSX.utils.sheet_to_json(worksheet, { 
                        header: 1,
                        defval: '',
                        blankrows: false,
                        raw: false  // This ensures all values are strings
                    });
                } catch (err) {
                    reject(new Error('Erreur lors de la conversion des données Excel'));
                    return;
                }
                
                if (jsonData.length < 5) {
                    reject(new Error('Le fichier doit contenir au moins 5 lignes (en-têtes + données)'));
                    return;
                }
                
                const prospects: ProspectCSVData[] = [];
                
                // Convert Excel rows to CSV-like format and use the existing parser
                for (let i = 4; i < jsonData.length; i++) {
                    const row = jsonData[i];
                    
                    // Skip empty rows
                    if (!row || row.every((cell: any) => !cell || cell === '')) {
                        continue;
                    }
                    
                    // Convert row to string array (same format as CSV)
                    const stringRow = row.map((cell: any) => {
                        if (cell === null || cell === undefined) return '';
                        return String(cell).trim();
                    });
                    
                    // Use the existing CSV parser
                    const prospect = parseProspectFromCSVRow(stringRow);
                    if (prospect) {
                        prospects.push(prospect);
                    }
                }
                
                resolve(prospects);
            } catch (error) {
                reject(new Error('Erreur inattendue lors du traitement du fichier Excel'));
            }
        };
        
        reader.onerror = () => {
            reject(new Error('Erreur lors de la lecture du fichier'));
        };
        
        reader.readAsBinaryString(file);
    });
}



}
